module.exports = __webpack_public_path__ + "static/media/all.baf0f327.pred";